export default "__VITE_ASSET__CoptAZ2r__"